export interface AlignedProperty {
    alignedValue: number;
    additional: number;
}

export function alignProperty(original: number, actual: number): AlignedProperty {
    let additional = 0;
    const aligned = actual;
    if (original > actual) {
        additional += 1;
    }
    const result: AlignedProperty =
    {
        alignedValue: aligned,
        additional: additional
    };
    return result;
}